import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const findUserRoles = createAsyncThunk(
  "templateDetail/findUserRoles",
  async (id, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const userRoleList = state.templateDetail.userRoleList;
    let maxUpdate: number = 0;

    if (userRoleList.length > 0) {
      const orderedList = [...userRoleList].sort((a, b) => {
        if (a.updatedAt && b.updatedAt && a.updatedAt < b.updatedAt) {
          return -1;
        }
        if (a.updatedAt && b.updatedAt && a.updatedAt > b.updatedAt) {
          return 1;
        }
        return 0;
      });
      maxUpdate = orderedList[orderedList.length - 1].updatedAt!;
    }

    try {
      const { data } = await axiosInstance.get(`${api.baseURL}userrole`, {
        params: {
          where: {
            enabled: true,
            updatedAt: { '>': maxUpdate }
          },
          limit: 4000,
        },
      });

      let newList = [...userRoleList.filter((element: any) => element.enabled === true)];

      data.forEach((element: any) => {
        if (newList.find(el => el.id === element.id)) {
          let user = newList.find(el => el.id === element.id);
          const indexToUpdate = newList.indexOf(user!);
          newList.splice(indexToUpdate, 1);
          newList.push(element);
        } else {
          newList.push(element);
        }
      });

      return newList;

    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
